module.exports = __webpack_public_path__ + "static/media/slideshow-42.0a766d65.jpeg";